'use strict';

angular.module('TurneroApp').service('tramitesService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Tramite/:id', { id: '@Id_Tramite' }, {
        getTramiteInfo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Tramite/GetTramiteInfo',
            headers: portal.getHeadersServer()
        },
        getfiltro: {
            method: 'GET',
            withcredentials: true,
            url: portal.getUrlServer() + 'api/Tramite/tramites',
            params: {
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
                texto: '@texto'
            },
        },
        save: {
            method: 'POST',
            url: portal.getUrlServer() + 'api/Tramite/tramites/'
        },
        'delete': {
            method: 'DELETE',
        },
        update: {
            method: 'PUT',
            params: {
                id: '@id'
            },
            url: portal.getUrlServer() + 'api/Tramite/tramites/:id',
        },
        putRestriccion: {
            method: 'PUT',
            headers: {
                'Content-Type': undefined
            },
            transformRequest: angular.identity,
            params: {
              id: '@id'
            },
            url: portal.getUrlServer() + 'api/Tramite/tramites/:id/usuarios-habilitados',
        }, 
        deleteRestriccion: {
            method: 'DELETE',
            params: {
                id: '@id'
            },
            url: portal.getUrlServer() + 'api/Tramite/tramites/:id/usuarios-habilitados',
        },
    }
);
}]);



// WEBPACK FOOTER //
// ./app/components/tramites/tramitesService.js